import authSlice from "./slices/authSlice";
import profileSlice from "./slices/profileSlice";
import workoutSlice from "./slices/workoutSlice";
import exerciseSlice from "./slices/exerciseSlice";
import adminEnvSlice from "./slices/adminEnvSlice";

const rootReducer = {
  profileSlice: profileSlice.reducer,
  authSlice: authSlice.reducer,
  workoutSlice: workoutSlice.reducer,
  exerciseSlice: exerciseSlice.reducer,
  adminEnvSlice: adminEnvSlice.reducer,
};

export default rootReducer;
